import { useSyncExternalStore } from 'react'

/**
 * Pontos de quebra canônicos — os mesmos de `globals.css`. Prefira CSS (`desk:`, `max-desk:`)
 * para diferenças de estilo; use estes hooks só quando a ESTRUTURA muda (ex.: tabela vira lista de cartões
 * com outra composição, sidebar recolhida por padrão).
 */
export const BREAKPOINTS = {
  tablet: 768,
  desk: 900,
  wide: 1280,
} as const

export type Breakpoint = keyof typeof BREAKPOINTS

function subscribe(query: string, callback: () => void) {
  if (typeof window === 'undefined' || !window.matchMedia) return () => {}
  const mql = window.matchMedia(query)
  mql.addEventListener('change', callback)
  return () => mql.removeEventListener('change', callback)
}

export function useMediaQuery(query: string, fallback = false) {
  return useSyncExternalStore(
    (cb) => subscribe(query, cb),
    () =>
      typeof window !== 'undefined' && window.matchMedia
        ? window.matchMedia(query).matches
        : fallback,
    () => fallback,
  )
}

/** `useBreakpoint('desk')` → verdadeiro a partir de 900px. */
export function useBreakpoint(name: Breakpoint, fallback = false) {
  return useMediaQuery(`(min-width: ${BREAKPOINTS[name]}px)`, fallback)
}

/** Dispositivo de toque sem ponteiro fino (iPhone, iPad sem trackpad): alvos de 48px e ações sempre visíveis. */
export function useCoarsePointer() {
  return useMediaQuery('(pointer: coarse)')
}
